/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown>, name: NonNullable<unknown> }} Live_Item_Updated_ByInputs */

const en_live_item_updated_by = /** @type {(inputs: Live_Item_Updated_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} updated by ${i?.name}`)
};

const de_live_item_updated_by = /** @type {(inputs: Live_Item_Updated_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} aktualisiert von ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{key} updated by {name}" |
*
* @param {Live_Item_Updated_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const live_item_updated_by = /** @type {((inputs: Live_Item_Updated_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Item_Updated_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_live_item_updated_by(inputs)
	return en_live_item_updated_by(inputs)
});